import { TemplateConfig } from '../../../template-config.interface';
import { SHARED_ESPN_CONFIG } from '../shared';
import { SPORTS, RUGBY_ROUNDS } from './data/sports';
import { AccordionConfig } from '../../../../../types/accordion';
import { tokens } from '../../../../../theme/tokens';

const ACCORDION_CONFIG: AccordionConfig[] = [
  {
    key: 'config',
    title: 'Configuración del template',
    subtitle: 'Deporte, liga y formato',
    fields: ['title', 'sport', 'league', 'round'],
    defaultOpen: true,
    color: tokens.colors.brands.blue[200]
  },
  {
    key: 'match',
    title: 'Información del partido',
    subtitle: 'Equipos, fecha y detalles del encuentro',
    fields: ['team1', 'team2', 'date', 'day', 'channel', 'tournament'],
    defaultOpen: true,
    color: tokens.colors.brands.blue[200]
  },
  {
    key: 'regions',
    title: 'Horarios por región',
    subtitle: 'Configurar horarios para diferentes zonas',
    fields: ['autoSyncTimes', 'region1', 'time1', 'region2', 'time2', 'region3', 'time3', 'region4', 'time4'],
    defaultOpen: true,
    color: tokens.colors.brands.blue[200],
    layout: 'grid'
  }
];

export const disneyEspnVS: TemplateConfig = {
  id: 'espn/espn-vs',
  clientId: 'DISNEY',
  title: 'VS ESPN',
  description: 'Template ESPN deportivo unificado',
  aspectRatio: 'vertical',
  image: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/ESPN-VS_generico.png',
  optimized_image:
    'https://media.backend.doer.ar/brands/assets/DISNEY/templates/thumbnails/optimized/ESPN-VS_generico.png',
  video: '',
  video_1080x1920: 'https://media.backend.doer.ar/brands/assets/DISNEY/templates/previews/espn_vs/ESPN-VS_generico.mp4',

  bannerType: 'espn/espn-vs',

  config: {
    renderer: 'accordion',
    accordionConfig: ACCORDION_CONFIG
  },

  formFields: [
    {
      key: 'title',
      label: 'Nombre del proyecto',
      type: 'input',
      placeholder: 'Nombre para identificar este asset',
      required: true
    },
    {
      key: 'sport',
      label: 'Deporte',
      type: 'select',
      required: true,
      options: SPORTS
    },
    {
      key: 'league',
      label: 'Liga',
      type: 'select',
      required: true,
      options: []
    },
    {
      key: 'round',
      label: 'Ronda',
      type: 'select',
      required: false,
      options: RUGBY_ROUNDS,
      defaultValue: RUGBY_ROUNDS[0]?.value,
      helperText: ['Solo para Rugby URBA Top 12']
    },
    {
      key: 'team1',
      label: 'Equipo 1',
      type: 'select',
      options: [],
      required: true,
      allowAutocompleteInput: true,
      excludeSelectedOf: ['team2']
    },
    {
      key: 'team2',
      label: 'Equipo 2',
      type: 'select',
      options: [],
      required: true,
      allowAutocompleteInput: true,
      excludeSelectedOf: ['team1']
    },
    {
      key: 'date',
      label: 'Fecha',
      type: 'calendar',
      placeholder: 'YYYY/MM/DD',
      required: true,
      showLiveOption: true
    },
    {
      key: 'day',
      label: 'Día',
      type: 'select',
      options: SHARED_ESPN_CONFIG.days,
      defaultValue: 'domingo',
      required: true
    },
    {
      key: 'autoSyncTimes',
      label: 'Sincronizar horarios desde Argentina',
      type: 'switch',
      defaultValue: true,
      required: false
    },
    {
      key: 'region1',
      label: 'Región',
      type: 'select',
      options: SHARED_ESPN_CONFIG.regions,
      defaultValue: 'arg/uru',
      required: true
    },
    {
      key: 'time1',
      label: 'Hora',
      type: 'time',
      placeholder: '19:00',
      required: true
    },
    {
      key: 'region2',
      label: 'Región',
      type: 'select',
      options: SHARED_ESPN_CONFIG.regions,
      defaultValue: 'cl',
      required: false
    },
    {
      key: 'time2',
      label: 'Hora',
      type: 'time',
      placeholder: '21:00',
      required: false
    },
    {
      key: 'region3',
      label: 'Región',
      type: 'select',
      options: SHARED_ESPN_CONFIG.regions,
      defaultValue: 'col/pe',
      required: false
    },
    {
      key: 'time3',
      label: 'Hora',
      type: 'time',
      placeholder: '23:00',
      required: false
    },
    {
      key: 'enableRegion4',
      label: '',
      type: 'switch',
      defaultValue: false,
      required: false
    },
    {
      key: 'region4',
      label: 'Región',
      type: 'select',
      options: SHARED_ESPN_CONFIG.regions,
      defaultValue: 'mx',
      required: false
    },
    {
      key: 'time4',
      label: 'Hora',
      type: 'time',
      placeholder: '01:00',
      required: false
    },
    {
      key: 'channel',
      label: 'Canal',
      type: 'select',
      options: SHARED_ESPN_CONFIG.channels,
      defaultValue: 'espn y disney+',
      required: true
    },
    {
      key: 'tournament',
      label: 'Torneo',
      type: 'select',
      options: [],
      required: true
    }
  ],

  promptTemplate: `Haceme un asset "vs_URBA Top 12" entre los equipos "SIC" y "Alumni"`
};
